import {mainSpecialistVideo} from "../main-specialist-video/main-specialist-video";
import axios from "axios";
import { createLoader } from '../loader/loader';
import {initNewGallery} from "../swiper/swiper";

const classPrefix = 'main-specialists'
const dataPrefix = 'data-main-specialists'
const $container = document.querySelector(`[${dataPrefix}]`)

if ($container) {
    mainSpecialists({$container})
}
export function mainSpecialists({$container}) {
    const $specialistTemplate = document.querySelector(`[${dataPrefix}-container-template]`);
    const $specialistSwiperTemplate = document.querySelector(`[${dataPrefix}-video-swiper-template]`);
    const $loader = $container.querySelector(`[${dataPrefix}-loader]`);

    let specialists = [];
    const specialistsImages = [];

    init();

    async function init() {
        await getSpecialists();
    }

    async function getSpecialists() {
        try {
            const response = await axios.get('/api/specialists');
            specialists = response.data.specialists || [];
            specialists.forEach((specialist, index) => initSpecialist(specialist, index));
        } catch (error) {
            console.error('Ошибка при загрузке специалистов:', error);
        } finally {
            $loader.style.display = 'none';
        }
    }

    function initSpecialist(specialist, index) {
        const $specialistClone = document.importNode($specialistTemplate.content, true);
        const $swiperClone = document.importNode($specialistSwiperTemplate.content, true);
        const swiperClass = `swiper-video-specialist-${index}`;

        const $specialistName = $specialistClone.querySelector(`[${dataPrefix}-name]`);
        const $specialistImage = $specialistClone.querySelector(`[${dataPrefix}-image]`);
        const $specialistExp = $specialistClone.querySelector(`[${dataPrefix}-exp]`);
        const $specialistTagList = $specialistClone.querySelector(`[${dataPrefix}-tag-list]`);
        const $specialistAbout = $specialistClone.querySelector(`[${dataPrefix}-about]`);
        const $specialistAboutMore = $specialistClone.querySelector(`[${dataPrefix}-about-more]`);


        // Добавляем в массив для оптимизации
        specialistsImages.push({ element: $specialistImage, specialist });

        function updateSpecialistImage() {
            const isMobile = window.innerWidth <= 768;
            $specialistImage.src = specialist.image_m && isMobile
                ? `storage/specialists/${specialist.id}/${specialist.image_m}`
                : `storage/specialists/${specialist.id}/${specialist.image}`;
        }

        updateSpecialistImage();

        $specialistName.innerText = specialist.name;
        $specialistAbout.innerText = specialist.about;
        $specialistExp.innerText = calculateExperience(specialist.experience);

        $specialistAboutMore.addEventListener('click', (event) => {
            event.preventDefault();
            if ($specialistAbout.classList.contains(`${classPrefix}__container-specialist-about-text--expanded`)) {
                $specialistAbout.classList.remove(`${classPrefix}__container-specialist-about-text--expanded`);
                $specialistAboutMore.innerText = 'Подробнее о специалисте';

            } else {
                $specialistAbout.classList.add(`${classPrefix}__container-specialist-about-text--expanded`);
                $specialistAboutMore.innerText = 'Свернуть';
            }
        });

        const $fragment = document.createDocumentFragment();
        specialist.tags.forEach(tag => {
            const $tag = document.createElement('div');
            $tag.classList.add(`${classPrefix}__container-specialist-list-tag`);
            $tag.innerText = tag.name;
            $fragment.appendChild($tag);
        });
        $specialistTagList.appendChild($fragment);

        const $contentList = $specialistClone.querySelector(`[${dataPrefix}-container-content-list]`);
        $swiperClone.querySelector('.swiper').classList.add(swiperClass);
        const $swiperWrapper = $swiperClone.querySelector('.swiper-wrapper');

        $contentList.appendChild($swiperClone);
        $container.appendChild($specialistClone);
    }

    function updateAllSpecialistImages() {
        const isMobile = window.innerWidth <= 768;
        specialistsImages.forEach(({ element, specialist }) => {
            element.src = specialist.image_m && isMobile
                ? `storage/specialists/${specialist.id}/${specialist.image_m}`
                : `storage/specialists/${specialist.id}/${specialist.image}`;
        });
    }

    window.addEventListener('resize', updateAllSpecialistImages);

    function calculateExperience(experienceDate) {
        const years = new Date().getFullYear() - new Date(experienceDate).getFullYear();
        return `Стаж практики: ${years} ${years === 1 ? "год" : years >= 2 && years <= 4 ? "года" : "лет"}`;
    }
}
